import { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  useEffect(() => {
    document.title = '404 | CrossPay Solutions';
  }, []);

  return (
    <main id="main-content" className="bg-[#141414]">
      <div className="min-h-[60vh] flex items-center justify-center px-6">
        <motion.div
          className="text-center"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <p className="text-8xl md:text-9xl font-black font-headline tracking-tight gradient-text mb-6">
            404
          </p>
          <h1 className="text-3xl md:text-4xl font-black font-headline mb-4">
            Página no encontrada
          </h1>
          <p className="text-on-surface-variant text-lg mb-10 max-w-md mx-auto">
            La página que busca no existe o ha sido movida.
          </p>
          <Link
            to="/"
            className="inline-block px-8 py-3 bg-gradient-to-r from-purple-primary to-accent-magenta text-white rounded-xl font-bold font-headline hover:scale-105 active:scale-95 transition-transform"
          >
            Volver al Inicio
          </Link>
        </motion.div>
      </div>
    </main>
  );
}
